(function TripSummaryAddComponentMedia($, Adzuki)
{
	'use strict';

	const component = {
		emits: [
			'component-event',
		],
		inject: [
			'getFaIconStyle',
		],
		props: {
			componentId: {
				type    : Number,
				required: true,
			},
			componentType: {
				type    : String,
				required: true,
			},
		},
		template: '#ts-add-component-media',
		data() {
			return {
				addingLocationImages  : false,
				baseUri               : Adzuki.base_uri,
				fetchingLocationImages: false,
				loadingMediaItems     : false,
				locationResults       : [],
				hotelImagesResults    : [],
				locationSearchDisabled: false,
				media                 : [],
				section               : 'ts-component-image',
				sectionInfo           : {},
				selectedHotelImages   : [],
				selectedLocationImages: [],
			};
		},
		methods: {
			addLocationImages() {
				if (this.selectedLocationImages.length === 0 && this.selectedHotelImages.length === 0) {
					return Adzuki.StatusMessage('error', 'Please select at least one image');
				}

				this.addingLocationImages = true;

				const eventData = {
					type           : 'selected-location-images',
					location_images: this.selectedLocationImages,
					hotel_images   : this.selectedHotelImages,
				};

				this.$emit('component-event', eventData);

				this.addingLocationImages = false;

				this.closeModal();
			},
			closeModal() {
				this.$emit('component-event', { type: 'close-modal' });
			},
			async getHotelImages() {
				const url = '/TripSummaries/getHotelImages/' + this.componentId;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (response.error) {
						return;
					}

					if (response.hotel_images.length > 0) {
						this.hotelImagesResults = response.hotel_images;
					}
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error fetching hotel images: ${error.message}`);
				}
			},
			async getMedia() {
				const url = `${this.baseUri + '/Media/getMediaItems/' + this.section}`;

				this.loadingMediaItems = true;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error fetching Media items: No response from server');
					}

					// Media Hub reads need the terms accepted (MEDIA-288)
					if (response.code === 'tos_required') {
						this.media = [];

						return Adzuki.StatusMessage('error', 'Please accept the Maxx Media Terms and Conditions to use your media here. Open Maxx Media to review and accept them.');
					}

					this.media = response;

					Adzuki.MediaUrls.resolveAll(this.media).catch((error) => {
						console.error('Error loading media URLs:', error);
					});
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error fetching Media items: ${error.message}`);
				} finally {
					this.loadingMediaItems = false;
				}
			},
			async getSectionInfo() {
				const url = `${this.baseUri + '/MediaSection/getSection/' + this.section}`;

				try {
					const response = await Adzuki.Ajax.get(url);

					if (!response) {
						return Adzuki.StatusMessage('error', 'Error fetching Media Sections: No response from server');
					}

					this.sectionInfo = response;
				} catch (error) {
					return Adzuki.StatusMessage('error', `Error fetching Media items: ${error.message}`);
				}
			},
			hotelImageBgUrl(image) {
				// handle giata images
				if (image.large) {
					return image.large;
				}

				if (image.photo_url) {
					return image.photo_url;
				}

				// this is an all-inclusive property image
				if (image.filename) {
					return this.baseUri + '/' + image.image_path + encodeURIComponent(image.filename);
				}

				return null;
			},
			hotelImageIsSelected(image) {
				return this.selectedHotelImages.find(i => i.id === image.id);
			},
			resetLocationSearch() {
				this.locationSearchDisabled = false;
				this.locationResults        = [];
				this.selectedLocationImages = [];

				this.$refs.locationSearchInput.value = '';
			},
			selectHotelImage(image) {
				if (this.selectedLocationImages.length >= 10) {
					return Adzuki.StatusMessage('error', 'You can only select up to 10 images');
				}

				const found = this.selectedHotelImages.find(i => i.id === image.id);

				if (found) {
					this.selectedHotelImages = this.selectedHotelImages.filter(i => i.id !== image.id);
				} else {
					this.selectedHotelImages.push(image);
				}
			},
			selectLocationImage(image) {
				if (this.selectedLocationImages.length > 10) {
					return Adzuki.StatusMessage('error', 'You can only select up to 10 images');
				}

				if (this.selectedLocationImages.includes(image)) {
					this.selectedLocationImages = this.selectedLocationImages.filter(i => i !== image);
				} else {
					this.selectedLocationImages.push(image);
				}
			},
			selectMedia(media) {
				if (!media.media_id) {
					this.closeModal();

					return Adzuki.StatusMessage('error', 'No media found, could not add images to component');
				}

				const mediaIds = [];

				if (Array.isArray(media.media_id)) {
					mediaIds.push(...media.media_id);
				} else {
					mediaIds.push(media.media_id);
				}

				const eventData = {
					type : 'selected-media',
					media: mediaIds,
				};

				this.$emit('component-event', eventData);

				this.closeModal();
			},
		},
		async mounted() {
			// location typeahead
			Adzuki.Typeahead(
				this.$refs.locationSearchInput,
				'/Searches/googleAutocomplete/',
				async (item, $self, typeahead) => {
					this.fetchingLocationImages = true;

					try {
						const url      = '/Searches/googlePlace/' + item.id + '/1';
						const response = await Adzuki.Ajax.get(url);

						if (response.error) {
							return Adzuki.StatusMessage('error', `Error getting location details: ${response.error}`);
						}

						if (!response || response.length === 0) {
							return Adzuki.StatusMessage('error', 'No images found');
						}

						this.locationResults        = response;
						this.locationSearchDisabled = true;
					} catch (error) {
						return Adzuki.StatusMessage('error', `Error getting place details: ${error.message}`);
					} finally {
						this.fetchingLocationImages = false;
					}
				},
				function template(item) {
					return item.name;
				}
			);

			// TODO: take another look at this, load the maxx media items only when the modal is opened
			// load maxx media items
			await this.getMedia();
			await this.getSectionInfo();

			if (this.componentType === 'lodging') {
				await this.getHotelImages();
			}
		},
	};

	Adzuki.VueComponents.TripSummaryAddComponentMedia = component;
}(jQuery, window.Adzuki || {}));
